import { useRouter } from 'next/router';
import { CustomLink } from '@/infra/link/CustomLink';
import { routes } from '@/config/routes';
import styles from '@/interface/ui/_shared/items/menu.module.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Search from '@/interface/ui/_shared/footer/icons/search';

type Props = {
  rowNumber: number;
  setRowNumber: (value: number | ((prevVar: number) => number)) => void;
  props: {
    mode?: 'default';
  };
};

const Menu: React.FC<Props> = ({ rowNumber, setRowNumber, props }) => {
  const router = useRouter();
  const isLaunch = /launch/.exec(router.pathname) != null;

  return (
    <div className={styles.menu}>
      <ul className={styles.ul}>
        <li className={styles.launch} key="launch">
          <CustomLink
            to={routes.launch}
            mode={props.mode}
            className={isLaunch ? styles.activeLink : styles.inActiveLink}
          >
            Launch
          </CustomLink>
          {isLaunch && <div className={styles.underline}></div>}
        </li>
        {/* <li className={styles.li} key="archives">
          <CustomLink
            to={routes.archives}
            mode={props.mode}
            className={!isLaunch ? styles.activeLink : styles.inActiveLink}
          >
            Archive
          </CustomLink>
          {!isLaunch && <div className={styles.underline}></div>}
        </li> */}
      </ul>
      <div
        className={styles.changeRowNumberButton}
        onClick={() => {
          if (rowNumber === 1) setRowNumber(2);
          else setRowNumber(1);
        }}
      >
        {rowNumber === 1 ? (
          <FontAwesomeIcon
            icon="th-large"
            color={colors.gray_1}
            size="lg"
            className={styles.multipleIcon}
          />
        ) : (
          <FontAwesomeIcon
            icon="square"
            color={colors.gray_1}
            size="lg"
            className={styles.singleIcon}
          />
        )}
        <CustomLink
          to={routes.search}
          mode={props.mode}
          className={styles.anchor}
        >
          <Search />
        </CustomLink>
      </div>
    </div>
  );
};

import colors from '@/constants/colors';
export default Menu;
